var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Storage from 'helpers/Storage';
import cxs from 'cxs/component';
import { renderTicket } from './Papel';
import theme from '../../../Theme';
import History from '../../../helpers/History';
import { adblockDetect } from '../../../helpers/Adblock';
let CashDeskListTicket = class CashDeskListTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticket: undefined,
            code: 0,
            message: '',
            result: '',
            visible: false
        };
        this.handleRefund = () => {
            const { ticket } = this.state;
            this.props.store.reports.refund(ticket, this.props.store.users.user)
                .then((value) => __awaiter(this, void 0, void 0, function* () {
                if (value.payload) {
                    console.log('TicketDetail - handleRefundTicket - ticket', value);
                    yield this.props.store.cashDeskTicketStore.actualizarRefundedTicket(value.payload);
                    const { result, code, message } = value;
                    this.setState({ result, code, message, ticket: value.payload, visible: true });
                }
                // Alert.alert(value.result, value.code === 200 ? `${value.message} importe a devolver: ${toMoneyDecimal(ticket.total)} ` : value.message)
            }))
                .catch(error => {
                console.log('TicketDetail - handleRefundTicket - catch - error: ', error);
            });
        };
        this.handleClose = () => {
            this.setState(prevState => ({ visible: !prevState.visible }));
        };
        this.handleView = (ticket) => {
            this.props.store.reports.pdf(ticket.numero).then(value => {
                let file = new Blob([value], { type: 'application/pdf', });
                if (adblockDetect()) {
                    let newWindow = window.open('/', '_blank', 'modal');
                    newWindow.onload = () => {
                        newWindow.location = URL.createObjectURL(file);
                    };
                }
                else {
                    let exportUrl = URL.createObjectURL(file);
                    window.open(exportUrl, '_blank', 'modal');
                }
            });
        };
        this.handleDownload = (ticket) => {
            this.props.store.reports.pdf(ticket.numero).then(value => {
                console.log('handleDownload - value: ', value);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE browser
                    console.log('if');
                    let blob = new Blob([value]);
                    window.navigator.msSaveOrOpenBlob(blob, ticket.numero);
                }
                else { // other browsers
                    console.log('else');
                    /*if (adblockDetect()) {
                      // let file = new File([value], ticket.numero + '.pdf', {type: 'application/pdf',/!* endings: 'transparent'*!/});
                      let file = new Blob([value],  {type: 'application/pdf',/!* endings: 'transparent'*!/});
            
                      let newWindow = window.open('/')
                      newWindow.onload = () => {
                        newWindow.location = URL.createObjectURL(file) as unknown as Location
                      }
            
                      let exportUrl = URL.createObjectURL(file)
                      // window.open(exportUrl, '_blank', 'modal')
                    } else {*/
                    //  Create a Blob from the PDF Stream
                    const filePdf = new Blob([value], { type: 'application/pdf' });
                    // Create a link pointing to the ObjectURL containing the blob
                    const data = window.URL.createObjectURL(filePdf);
                    var link = document.createElement('a');
                    link.href = data;
                    link.download = ticket.numero;
                    link.click();
                    setTimeout(() => {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        window.URL.revokeObjectURL(data);
                    }, 100);
                    /*}*/
                }
            });
            /*this.props.store.reports.pdfPost(rendered).then(value => {
              console.log('handleDownload - then - value: ', value)
        
              //  Create a Blob from the PDF Stream
              /!*const filePdf = new Blob([value], {type: 'application/pdf', endings: 'transparent'})
              // Build a URL from the file
              const fileURL = URL.createObjectURL(filePdf);
              // Open the URL on new Window
              window.open(fileURL);*!/
        
              /!*if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                console.log('if')
                let blob = new Blob([value], {type: 'application/pdf'});
                window.navigator.msSaveOrOpenBlob(blob, ticket.numero);
              } else {// other browsers
                console.log('else')
                let file = new File([value], ticket.numero + '.pdf', {type: 'application/pdf', endings: 'transparent'});
                let exportUrl = URL.createObjectURL(file);
                // window.location.assign(exportUrl);
                // URL.revokeObjectURL(exportUrl);
                window.open(exportUrl)
              }*!/
            })*/
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const user_id = this.props.store.users.user.id;
            const caja = JSON.parse(Storage.get(user_id.toString()));
            // console.log ('Papel - componentDidMount() - caja: ', caja)
            // await this.props.store.stretchesStore.read()
            yield this.props.store.structureStore.getStructure(this.props.store);
            this.setState({ ticket: this.props.location.state });
        });
    }
    componentWillMount() {
        this.state.ticket = this.props.location.state;
        const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        // console.log('StretchesList - componentDidMount - hasParent', hasParent)
        this.props.store.UI.changeHasParent(hasParent);
    }
    render() {
        const { ticket, visible, code, message, result } = this.state;
        const disable = ticket.daterefund !== null;
        // console.log('CashDeskListTicket - render() - item', ticket)
        return (React.createElement(Wrapper, null,
            React.createElement(WrapperTicket, null, renderTicket(ticket, this.props.store.stretchesStore.findBusinessunitByStretchId(ticket.stretch_id)))));
    }
};
CashDeskListTicket = __decorate([
    inject('store'),
    observer
], CashDeskListTicket);
export default CashDeskListTicket;
const Wrapper = cxs('div')({});
const WrapperButton = cxs('div')({
    width: '92%',
    marginRight: '10px',
    marginLeft: '10px',
    position: 'absolute',
    top: theme.size.bar,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: 'white'
});
const WrapperTicket = cxs('div')({
    paddingTop: '50px',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/CashDeskListTicket.tsx
// module id = 534
// module chunks = 0